var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScrap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#33A6FF",
  d: "M12.016 2.191h-7.68c-.848 0-1.536.688-1.536 1.536v16.474a1.512 1.512 0 0 0 2.212 1.34l7.004-3.66 7.004 3.66a1.512 1.512 0 0 0 2.212-1.34V3.727c0-.848-.688-1.536-1.536-1.536z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF4BE",
  d: "M11.695 5.885a.384.384 0 0 1 .643 0l1.438 2.21c.052.08.13.137.222.162l2.546.684a.384.384 0 0 1 .2.612l-1.658 2.05a.38.38 0 0 0-.085.262l.136 2.633a.384.384 0 0 1-.521.378l-2.462-.943a.38.38 0 0 0-.275 0l-2.462.943a.384.384 0 0 1-.52-.378l.135-2.633a.38.38 0 0 0-.085-.261L7.29 9.553a.384.384 0 0 1 .199-.613l2.546-.684a.38.38 0 0 0 .222-.162z"
})));
export default SvgScrap;